


















































































































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class PlaygroundButtonPure extends Vue {
  public size: string = 'medium';
  public weight: string = 'thin';
  
  public get isInherit() {
    return this.size === 'inherit' ? 'font-size: 48px;' : undefined;
  }
}
